import { Types } from '../action/action';

const initialState = {
  internet: false,
  navigation: false
};

export const internetReducer = (state:any  = initialState, action: any) => {
  const {
    type,
    payloads
  } = action;
  switch (type) {
      case Types.CHECK_INTERNET:
        return {
          ...state, internet: payloads.internet
        };
        case Types.CHECK_NAVIGATION:
        return {
          ...state, navigation: payloads.navigation
        };
  default:
    return state;
  };
};